<template>
    <div>
        <div v-show="treatment_params == false">
            Table
            <b-input :list="'table' + id"  @change="set_table()" v-model="table" />
            <datalist :id="'table' + id">
                <option v-for="(table, idx_column) in tables" :key="'table' + idx_column">{{table}}</option>
            </datalist>
            <br />
        </div>

        <div v-if="treatment_params">
            <b-form inline>
				<b-input-group style="width:300px" prepend="Nom">
					<b-form-input v-model="name"></b-form-input>
				</b-input-group>
				<b-button v-b-modal="'modal' + id">Charger</b-button>
				<b-button @click="save_library" :disabled="!version || !name"><i class="fas fa-save"></i></b-button>
			</b-form>

			<b-modal :hide-footer="true" :id="'modal' + id" title="Charger">
				<span>Nom</span>
				<v-select v-model="load_name" :options="names"></v-select>
			</b-modal>
        </div>

        <draggable :group="'array-' + id" :list="mapping" class="list-group" handle=".handle">
            <b-card v-for="(column, idx) in mapping" :key="idx">
                <div v-show="column.minimal">
                    {{ column.name }}

                    <b-button variant="link" @click="set_minimal(idx, false)"><i class="fas fa-eye"></i></b-button>
                </div>
                <div v-show="!column.minimal">
                    <div>
                        Destination
                        <b-input :list="'name' + id + '-' + idx"  v-model="column.name" />
                        <datalist :id="'name' + id + '-' + idx">
                            <option v-for="(column, idx_column) in columns_table" :key="'column' + idx_column">{{column}}</option>
                        </datalist>
                    </div>
                    <div>
                        Origines
                        <draggable :group="'array-' + id + '-' +  idx" :list="column.values" class="list-group" handle=".handle_value">
                            <b-container style="margin: 0; padding: 0; max-width: none;">
                                <b-row v-for="(value, idx_value) in column.values" :key="idx_value">
                                    <b-col cols="2">
                                        <b-select v-model="value.type" :options="[
                                            {value: 'column', text: 'Colonne'},
                                            {value: 'value', text: 'Valeur'}
                                        ]" />                                    
                                    </b-col>
                                    <b-col cols="8">
                                        <div v-if="value.type == 'column'">
                                            <b-input @change="column.is_list ? set_list() : ''" :list="'source' + id + '-' + idx"  v-model="value.value" placeholder="Colonne"/>
                                            <datalist :id="'source' + id + '-' + idx">
                                                <option v-for="(column, idx_column) in columns_data" :key="'column' + idx_column">{{column}}</option>
                                            </datalist>
                                        </div>
                                        <div v-else>
                                            <b-input @change="set_table_list_values(value.list)" style="width:35%; display:inline-block" :list="'source-liste' + id + '-' + idx" v-model="value.list" placeholder="Liste" />
                                            <datalist :id="'source-liste' + id + '-' + idx">
                                                <option v-for="(type, idx_type) in list_types" :key="'type' + idx_type">{{type}}</option>
                                            </datalist>
                                            &nbsp;
                                            <span v-show="!value.list">
                                                <b-input v-show="!value.list" style="width:60%;display:inline-block" :list="'source' + id + '-' + idx"  v-model="value.value" placeholder="Valeur"/>
                                            </span>
                                            <b-select v-if="value.list" style="width:60%;display:inline-block" :options="table_list_values[value.list]" v-model="value.value" />
                                        </div>
                                    </b-col>
                                    <b-col cols="2">
                                        <b-button variant="link" class="handle_value"><i class="fas fa-arrows-alt"></i></b-button>
                                        <b-button variant="link" @click="del_value(idx, idx_value)"><i class="fas fa-trash"></i></b-button>
                                    </b-col>
                                </b-row>
                            </b-container>
                        </draggable>
                        <b-button variant="link" @click="add_value(idx, 'column')"><i class="fas fa-plus"></i></b-button>
                    </div>
                    <div>
                        Séparateur
                        <b-input :list="'separator' + id + '-' + idx" v-model="column.separator" />
                        <datalist :id="'separator' + id + '-' + idx">
                            <option>json</option>
                        </datalist>
                    </div>
                    <div>
                        Changement de valeurs
                        <b-checkbox @change="column.is_list ? set_list() : ''" v-model="column.is_list" />
                        <div v-if="column.is_list">
                            <b-container style="margin: 0; padding: 0; max-width: none;">
                                <b-row>
                                    <b-col>
                                        Table de référence
                                        <b-input @change="set_table_list(idx)" :list="'table' + id + '-' + idx" v-model="column.table_list" />
                                        <datalist :id="'table' + id + '-' + idx">
                                            <option v-for="(table, idx_column) in tables" :key="'table' + idx_column">{{table}}</option>
                                        </datalist>
                                    </b-col>
                                    <b-col>
                                        Colonne de référence
                                        <b-input @change="set_table_list(idx)" v-model="column.list" />
                                    </b-col>
                                    <b-col v-if="table_list">
                                        Type
                                        <b-input :list="'type' + id + '-' + idx" @change="set_default_value(idx)" v-model="column.list_type" />
                                        <datalist :id="'type' + id + '-' + idx">
                                            <option v-for="(type, idx_type) in list_types" :key="'type' + idx_type">{{type}}</option>
                                        </datalist>
                                        
                                    </b-col>
                                </b-row>
                            </b-container>

                            <b-container style="margin: 0; padding: 0; max-width: none;">
                                <b-row>
                                    <b-col cols="5">
                                        Valeur
                                    </b-col>
                                    <b-col cols="5">
                                        Nouvelle valeur
                                    </b-col>
                                    <b-col>
                                    </b-col>
                                </b-row>
                            </b-container>
                            <div v-for="(value, key) in column.conversion" :key="idx + '-' + key">
                                <b-container style="margin: 0; padding: 0; max-width: none;">
                                    <b-row>
                                        <b-col cols="5">
                                            {{ key }}
                                        </b-col>
                                        <b-col cols="5">
                                            <b-input @change="(column.list_type && table_list) ? set_value_list(column.conversion[key], key, column.list_type) : ''" :list="'table_list' + id + '-' + idx + '_' + key" v-model="column.conversion[key]" />
                                            <datalist :id="'table_list' + id + '-' + idx + '_' + key">
                                                <option v-for="(table_list_value, idx_value) in column.table_list_values" :key="'table' + idx_value">{{table_list_value}}</option>
                                            </datalist>
                                        </b-col>
                                        <b-col cols="2">
                                            <b-button variant="link" @click="del_conversion(idx, key)"><i class="fas fa-trash"></i></b-button>
                                        </b-col>
                                    </b-row>
                                </b-container>
                            </div>
                            <br />
                            Ajouter une valeur :
                            <b-input style="display:inline-block; width:40%" v-model="conversion_input[idx]" />
                            <b-button variant="link" @click="add_conversion(idx)"><i class="fas fa-plus"></i></b-button>
                        </div>                    
                    </div>
                    <b-button variant="link" class="handle"><i class="fas fa-arrows-alt"></i></b-button>
                    <b-button variant="link" @click="del(idx)"><i class="fas fa-trash"></i></b-button>                    
                    <b-button variant="link" @click="set_minimal(idx, true)"><i class="fas fa-eye-slash"></i></b-button>
                </div>
            </b-card>
        </draggable>        
        
        <b-button variant="link" @click="add()"><i class="fas fa-plus"></i></b-button>

        <div v-if="columns_data.length > 0">
            Colonnes du csv non utilisées dans les origines
				<b-button
					variant="link"
					v-b-toggle="'collapse-columns_data-' +  id"
					><i v-if="collapse_columns_data" class="fas fa-eye-slash"></i
					><i v-if="!collapse_columns_data" class="fas fa-eye"></i
				></b-button>
            <b-collapse :id="'collapse-columns_data-' +  id" v-model="collapse_columns_data">
                <div v-for="(column, idx) in columns_data.filter(column => mapping.map(obj => obj.values.map(_obj => _obj.value)).reduce(function(pre, cur) {
                        return pre.concat(cur);
                    }, []).includes(column) ? false : true)" :key="idx">
                    {{column}}
                </div>
            </b-collapse>
        </div>

        <div v-if="columns_table.length > 0">
            Colonnes de la table non utilisées dans les destinations
				<b-button
					variant="link"
					v-b-toggle="'collapse-columns_table-' +  id"
					><i v-if="collapse_columns_table" class="fas fa-eye-slash"></i
					><i v-if="!collapse_columns_table" class="fas fa-eye"></i
				></b-button>
            <b-collapse :id="'collapse-columns_table-' +  id" v-model="collapse_columns_table">
                <div v-for="(column, idx) in columns_table.filter(column => mapping.map(obj => obj.name).includes(column) ? false : true)" :key="idx">
                    {{column}} <b-button size="sm" variant="link" @click="add(column)"><i class="fas fa-plus"></i></b-button>
                </div>
            </b-collapse>
        </div>

        <div v-if="treatment_params">
            <b-button @click="test">Test du mapping</b-button>

            <edit_tabulator :extern_file="false" ref="tabulator" />
        </div>
    </div>
</template>

<script>
	import draggable from "vuedraggable";
    import uniqueId from "lodash.uniqueid";

	import edit_tabulator from "./edit_tabulator.vue";
	import database from "../services/database.js";
    import library from "../services/library.js";
	import workers from "../services/workers.js";

    var clone = require("clone");
    
    export default {
        name: "mapping",
		components: {
            draggable,
            edit_tabulator
		},
		props: {
            treatment_params: {
                default: false
            },
            files: {
                default: () => []
            },
			data: {
				default: () => [],
            },
			client: {
				default: null
			},
        },
        watch: 
        {
			load_name: {
				async handler() {
					if (this.load_name) 
						await this.load_library();
				},
			},
            data: {
                deep: true,
                immediate: true,
                handler()
                {
                    if (this.data.length != 0)
                    {
                        this.columns_data = Object.keys(this.data[0]);
                        this.set_list();
                    }
                }
            },
            files: {
                deep: true,
                immediate: true,
                handler()
                {
                    //console.log(this.files);

                    if (this.files.length > 0)
                    {
                        var self = this;
                        var reader = new FileReader();

                        reader.onload = (function (theFile) {
                            return function (e) {
                                if (e.target.result)
                                {
                                    var data = self.$papa.parse(e.target.result, { header: true });
                                    if (data.data && data.data.length > 0)
                                    {
                                        self.file_data = data.data;
                                        self.columns_data = Object.keys(data.data[0]);
                                        self.set_list();
                                    }
                                }
                            };
                        })(this.files[0].file ? this.files[0].file : this.files[0]);

                        reader.readAsText(this.files[0].file ? this.files[0].file : this.files[0]);
                    }
                }
            }
        },
        computed: {
            
        },
		data() {
			return {
                id: uniqueId(""),

                name: "",
                load_name: "",
				names: [],
				version: "1",
                type: "mapping",
                file_data: [],
                table_list_values: {},

                table_list: "",
                lists: {},
                list_types: [],

                mapping: [],
                conversion_input: {},
                columns_data: [],
                table: "",
                columns_table: [],
                tables: [],
                collapse_columns_data: false,
                collapse_columns_table: false
			};
        },
        methods: {
            async set_table_list_values(type)
            {
                console.log("set_table_list_values " + type);
                if (type)
                {
                    var table_list_values = [];

                    var response = await database.get("select", this.table_list, {
                        select: "*",
                        where: `\`type\` = "${type}"`
                    });

                    for (var i = 0; i < response.length; i++)
                    {
                        table_list_values.push({value: response[i].key, text: response[i].value })
                    }

                    this.$set(this.table_list_values, type, table_list_values);
                }
            },
            async test()
            {
                var self = this;
                var data = [];

                if (this.data && this.data.length > 0)
                    data = clone(this.data);

                if (this.file_data && this.file_data.length > 0)
                   data = clone(this.file_data);

                var params = await workers.get_params({
                    parameters: this.save(),
                    action: "mapping"
                });
                console.log(params)

                var results = await workers.execute("csv", params.body, data);

                console.log(results)

                this.$refs.tabulator.set_data(data);

            },
			async save_library()
			{
				var data = this.save();

				await library.save(
					this.name,
					this.version,
					data,
					this.type,
					false,
					{},
					true 
				);
				await this.set_name();

				this.$notify({
					group: "info",
					title: "Enrgistrement effectué",
					type: "success"
				});
			},
			async load_library()
			{
				var data = await library.load(
					this.load_name,
					this.version,
					this.type
				);
                this.name = this.load_name;
                this.load(data);
            },
            async set_value_list(value, key, type)
            {
                if (!this.lists[type])
                    this.lists[type] = {};

                if (!this.lists[type][key])
                {
                    await database.get("insert into", this.table_list, {
                        columns: ['type', 'key', 'value'],
                        data: {
                            type,
                            key,
                            value
                        }
                    });

                    var response = await database.get("select", this.table_list, {
                            select: "*",
                            where: `\`type\` = "${type}" and \`key\` = "${key}"`
                        });

                    this.lists[type][key] = response[0].id;
                }
                else
                {
                    var response = await database.get("update", this.table_list, {
                        where: 'id = ' + this.lists[type][key],
                        set: 'value = "' + value + '"'
                    });
                }
            },
            async set_default_value(idx)
            {
                if (this.table_list && this.mapping[idx].list_type)
                {
                    for (var k = 0; k < this.mapping[idx].values.length; k++)
                    {
                        if (this.mapping[idx].is_list && this.data[0].hasOwnProperty(this.mapping[idx].values[k].value))
                        {
                            var keys = Object.keys(this.mapping[idx].conversion);
                            for (var i = 0; i < keys.length; i++)
                            {
                                if (this.mapping[idx].conversion[keys[i]])
                                    this.set_value_list(this.mapping[idx].conversion[keys[i]], keys[i], this.mapping[idx].list_type)
                            }

                            var list = "";
                            for (var j = 0; j < this.data.length; j++)
                            {
                                var key = this.data[j][this.mapping[idx].values[k].value].toLowerCase().trim();
                                if (!list.includes(key))
                                {
                                    if (list)
                                        list += ",";
                                    list += '"' + key + '"';
                                }
                            }

                            var response = await database.get("select", this.table_list, {
                                select: "*",
                                where: `\`type\` = "${this.mapping[idx].list_type}" and \`key\` in (${list})`
                            });

                            if (!this.lists[this.mapping[idx].list_type])
                                this.lists[this.mapping[idx].list_type] = {};

                            for (var j = 0; j < response.length; j++)
                            {
                                this.lists[this.mapping[idx].list_type][response[j].key] = response[j].id;
                                this.$set(this.mapping[idx].conversion, response[j].key, response[j].value); 
                            }
                        }
                    }
                }
            },
			async set_name()
			{
				var names = await library.getby_production(this.type, null, false, false, false);
				names = names.element;

				this.names = [];
				for (var i = 0; i < names.length; i++) {
					this.names.push(names[i].name);
				}
			},
            del(idx)
            {
                this.mapping.splice(idx, 1);
            },
            del_value(idx, idx_value)
            {
                this.mapping[idx].values.splice(idx_value, 1);
            },
            del_conversion(idx, key)
            {
                this.$delete(this.mapping[idx].conversion, key);
            },
            add(name = "")
            {
                this.mapping.push({
                    name: name,
                    separator: "",
                    values: [],
                    conversion: {},
                    is_list: false,
                    table_list: "",
                    table_list_values: [],
                    list: "",
                    minimal: false
                })
            },
            add_value(idx, type)
            {
                this.mapping[idx].values.push({
                    type: type,
                    value: ""
                });
            },
            async add_conversion(idx)
            {
                var key = this.conversion_input[idx].toLowerCase().trim();

                var value = "";
                value = this.mapping[idx].table_list_values.find(element => element.toLowerCase() === key.toLowerCase());
                if (!value)
                    value = "";

                if (this.table_list && this.mapping[idx].list_type)
                {
                    var response = await database.get("select", this.table_list, {
                            select: "*",
                            where: `\`type\` = "${this.mapping[idx].list_type}" and \`key\` = "${key}"`
                        });

                    if (!this.lists[this.mapping[idx].list_type])
                        this.lists[this.mapping[idx].list_type] = {};
                    this.lists[this.mapping[idx].list_type][key] = response[0].id;
                    value = response[0].value;
                }

                this.$set(this.mapping[idx].conversion, key, value);

                this.conversion_input[idx] = "";
            },
            set_minimal(idx, value)
            {
                this.$set(this.mapping[idx], "minimal", value)
                this.$set(this.mapping, idx, this.mapping[idx])
            },    
            async set_list()
            {
                if (this.data.length > 0)
                {
                    for (var i = 0; i < this.mapping.length; i++)
                    {
                        for (var k = 0; k < this.mapping[i].values.length; k++)
                        {
                            if (this.mapping[i].is_list && this.data[0].hasOwnProperty(this.mapping[i].values[k].value))
                            {
                                var list = "";

                                if (this.table_list && this.mapping[i].list_type)
                                    this.mapping[i].conversion = {};

                                for (var j = 0; j < this.data.length; j++)
                                {
                                    var key = this.data[j][this.mapping[i].values[k].value].toLowerCase().trim();
                                    var value = "";
                                    value = this.mapping[i].table_list_values.find(element => element ? (element.toLowerCase() === key) : false);
                                    if (!value)
                                        value = "";
                                    if (!this.mapping[i].conversion[key])
                                    {
                                        this.$set(this.mapping[i].conversion, key, value); 
                                        if (list)
                                            list += ",";
                                        list += '"' + key + '"';
                                    }
                                }
                                if (this.table_list && this.mapping[i].list_type)
                                {
                                    var response = await database.get("select", this.table_list, {
                                        select: "*",
                                        where: `\`type\` = "${this.mapping[i].list_type}" and \`key\` in (${list})`
                                    });

                                    if (!this.lists[this.mapping[i].list_type])
                                        this.lists[this.mapping[i].list_type] = {};

                                    for (var j = 0; j < response.length; j++)
                                    {
                                        this.lists[this.mapping[i].list_type][response[j].key] = response[j].id;
                                        this.$set(this.mapping[i].conversion, response[j].key, response[j].value); 
                                    }
                                }
                            }
                        }
                    }
                }
            },
            async set_table()
            {
                if (this.table)
                {
                    let data = await database.get("show", this.table);

                    this.columns_table = [];
                    for (var i = 0; i < data.length; i++)
                    {
                        this.columns_table.push(data[i].Field);
                    }
                }
            },
            async set_table_list(idx)
            {
                console.log("set_table_list " + this.id);

                this.$set(this.mapping[idx], "table_list_values", []);

                if (!this.mapping[idx].table_list || !this.mapping[idx].list)
                    return;

                var mapping = [];

                var result = await database.get("SELECT", this.mapping[idx].table_list, {
					select: "DISTINCT " + this.mapping[idx].list + " AS list",
                });
                
                for (var i = 0; i < result.length; i++)
                {
                    mapping.push(result[i].list);
                }

                this.$set(this.mapping[idx], "table_list_values", mapping);

                var keys = Object.keys(this.mapping[idx].conversion);
                for (var i = 0; i < keys.length; i++)
                {
                    var value = "";
                    value = this.mapping[idx].table_list_values.find(element => element ? (element.toLowerCase() === keys[i]) : false);
                    if (!value)
                        value = "";
                    if (value)
                        this.$set(this.mapping[idx].conversion, keys[i], value); 
                }
            },
            get_data()
            {
                return this.save()
            },
            save()
            {
                var mapping = clone(this.mapping);

                for (var i = 0; i < mapping.length; i++)
                {
                    if (mapping[i].table_list_values)
                        delete mapping[i].table_list_values;
                }
                
                return {
                    mapping: mapping,
                    table: this.table
                }
            },
            async load(data)
            {
                console.log("load " + this.id)
                console.log(data);

                if (!data)
                {
                    return;
                }

                this.mapping = data.mapping;
                this.table = data.table || "";

                for (var i = 0; i < this.mapping.length; i++)
                {
                    if (this.table_list && this.mapping[i].list_type)
                        this.mapping[i].conversion = {};
                    for (var j = 0; j < this.mapping[i].values.length; j++)
                    {
                        if (this.mapping[i].values[j].list)
                            await this.set_table_list_values(this.mapping[i].values[j].list);
                    }
                }

                await this.set_table();

                for (var i = 0; i < this.mapping.length; i++)
                {
                    this.mapping[i].minimal = true;
                    if (this.mapping[i].is_list && this.mapping[i].table_list && this.mapping[i].list)
                        await this.set_table_list(i);
                }

                await this.set_list();
            }
        },
        async mounted()
        {			
            this.set_name();

            var tables = [];
            if (this.client.details && this.client.details.tables)
                tables = this.client.details.tables;

            if (tables && tables.length > 0) {
                for (var i = 0; i < tables.length; i++) {
                    this.tables.push(tables[i].name);
                }
            } 
            
            if (this.client.details && this.client.details.tables_obj && this.client.details.tables_obj.list)
            {
                this.table_list = this.client.details.tables_obj.list;

                var result = await database.get("SELECT", this.table_list, {
					select: "DISTINCT type",
                });
                
                for (var i = 0; i < result.length; i++)
                {
                    this.list_types.push(result[i].type);
                }
            }
        }
    }
</script>
